<template>
  <v-app id="inspire">
    <div id="nav-top-gradient"></div>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-toolbar-title>Next Gen Classes</v-toolbar-title>
    </v-app-bar>


    <v-main>
      <v-progress-linear
        indeterminate
        color="primary"
        :active="loading"
      ></v-progress-linear>
      <v-container
        class="fill-height"
        fluid
      >
        <v-sheet width="100%" height="100%">
          <v-row v-show="globalError">
            <v-col>
              <v-alert type="error" prominent>{{ this.globalError }}</v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="siteID"
                label="Site ID"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="memberID"
                label="Member ID"
                @blur="memberID && password && getClasses()"
                @keyup.enter="memberID && password && getClasses()"
              />
            </v-col>
            <v-col>
              <v-text-field
                type="password"
                v-model="password"
                label="Password"
                @blur="memberID && password && getClasses()"
                @keyup.enter="memberID && password && getClasses()"
              />
            </v-col>
          </v-row>
          <v-calendar
            ref="calendar"
            type="custom-weekly"
            event-overlap-mode="column"
            event-overlap-threshold="1"
            :events="classes"
            :start="bookingDates && bookingDates[0] && bookingDates[0].date"
            :end="bookingDates && bookingDates[bookingDates.length - 1] && bookingDates[bookingDates.length - 1].date"
            first-time="06:00"
            :event-color="() => 'transparent'"
            :event-height="40"
            :event-more="false"
            :max-days="9"
            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
            height="100%"
            locale="au"
            @click:event="showEvent"
          >
            <template #event="{ event }">
              <div class="pl-1 fill-height" :style="{ backgroundColor: getEventColor(event) }" :class="{ 'pulsing': pendingEvents.includes(`${event.id}_${event.start}`) }">
                <strong>{{ moment(event.start).format('h:mma') }}</strong>
                {{ getBookedClass(event) && getBookedClass(event).isOnWaitList ? ' (ON WAITLIST)' : '' }}
                {{ event.spaces ? `(${event.spaces} spots left)` : `(${event.waitlist} on waitlist)` }}
                <br />
                {{ event.name }} - {{ event.instructor }}
              </div>
            </template>
          </v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card
              color="grey lighten-4"
              min-width="350px"
              flat
            >
              <v-toolbar
                color="light-blue"
                dark
                flat
              >
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="selectedOpen = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col>
                    <strong>Time:</strong>
                  </v-col>
                  <v-col>
                    <span>{{ moment(selectedEvent.classMoment).format('h:mma') }} - {{ moment(selectedEvent.classMoment).add(selectedEvent.duration, 'minutes').format('h:mma') }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <strong>Instructor:</strong>
                  </v-col>
                  <v-col>
                    <span>{{ selectedEvent.instructor }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <strong>Spots Available:</strong>
                  </v-col>
                  <v-col>
                    <span v-if="selectedEvent.spaces > 0">{{ selectedEvent.spaces }}</span>
                    <span v-if="selectedEvent.spaces === 0">
                      Full ({{ selectedEvent.waitlist }} on waitlist)
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  v-if="!getBookedClass(selectedEvent)"
                  depressed
                  color="primary"
                  @click="bookClass(selectedEvent)"
                  :loading="loading"
                  :disabled="!selectedEvent.bookable"
                >
                  {{ (selectedEvent.spaces === 0) ? 'Register to Waitlist' : 'Book Class' }}
                </v-btn>
                <v-btn
                  v-if="getBookedClass(selectedEvent)"
                  depressed
                  color="error"
                  @click="cancelClass(selectedEvent)"
                  :loading="loading"
                >
                  {{ getBookedClass(selectedEvent).isOnWaitList ? 'Cancel Waitlist' : 'Cancel Booking' }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>

      </v-container>
    </v-main>
    <v-footer
      color="primary"
      app
    >
      <span class="white--text">By Nick Barrett</span>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment';

const storage = window.localStorage;

export default {

  data: () => ({
    baseApiUrl: 'https://members.ngclubs.com.au',
    authorization: storage.getItem('authorization'),
    memberID: storage.getItem('memberID'),
    password: storage.getItem('password'),
    siteID: storage.getItem('siteID') || 'KP',
    loading: false,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    bookings: storage.getItem('bookings') ? JSON.parse(storage.getItem('bookings')) : [],
    classes: storage.getItem('classes') ? JSON.parse(storage.getItem('classes')) : [],
    bookingDates: storage.getItem('bookingDates') ? JSON.parse(storage.getItem('bookingDates')) : [],
    fetchOpts: {
      referrer: 'no-referrer'
    },
    globalError: '',
    moment,
    debounceTimer: null,
    pendingEvents: [],
  }),

  async mounted() {
    if (this.authorization || (this.memberID && this.password)) await this.getClasses();
  },
  watch: {
    siteID() {
      storage.setItem('siteID', this.siteID);
    },
    memberID() {
      storage.setItem('memberID', this.memberID);
      this.globalError = '';
    },
    password() {
      storage.setItem('password', this.password);
      this.globalError = '';
    },
    authorization() {
      storage.setItem('authorization', this.authorization);
    },
    classes() {
      storage.setItem('classes', JSON.stringify(this.classes));
    },
    bookingDates() {
      storage.setItem('bookingDates', JSON.stringify(this.bookingDates));
    },
    bookings() {
      storage.setItem('bookings', JSON.stringify(this.bookings));
    }
  },
  methods: {
    async getAvailableBookingDates() {
      const apiUrl = `/api/ClubLounge/GetAvailableBookingDates?siteID=${this.siteID}`;
      const data = await this.get(apiUrl);
      if (!Array.isArray(data)) return;
      const bookingDates = data.map(d => d.dateAsISOString);
      this.bookingDates = await Promise.all(bookingDates.map(async (d) => ({
          date: d,
          bookable: await this.checkAdvanceBookings(d),
        })
      ));
    },
    async getClasses() {
      this.loading = true;
      if (!this.memberID || !this.password) return;
      if (!this.authorization) await this.getToken();
      if (!this.authorization) {
        this.loading = false;
       return;
      }
      await this.getAvailableBookingDates();
      await this.getBookings();

      const apiUrl = '/api/ClubLounge/AvailableClassesForDate';
      const data = await Promise.all(this.bookingDates.map(date => (
        this.post(apiUrl, {
          dateAsISOString: date.date,
          memberID: this.memberID,
          siteID: this.siteID,
        })
      )));
      this.classes = [].concat(...data).map(c => ({
        id: c.activityID,
        name: c.className,
        description: c.classDescription,
        dateTimeAsISOString: c.dateTimeAsISOString,
        classMoment: moment(c.dateTimeAsISOString),
        start: moment(c.dateTimeAsISOString).format('YYYY-MM-DD HH:mm'),
        end: moment(c.dateTimeAsISOString).add(c.duration, 'minutes').format('YYYY-MM-DD HH:mm'),
        duration: c.duration,
        instructor: c.instructorName,
        spaces: c.spacesAvailable >= 0 ? c.spacesAvailable : 0,
        waitlist: c.spacesAvailable < 0 ? Math.abs(c.spacesAvailable) : 0,
        location: c.location,
        bookable: this.bookingDates.find(d => d.date === moment(c.dateTimeAsISOString).format('YYYY-MM-DD'))?.bookable ?? false,
      })).sort((a, b) => {
        const diff = a.classMoment.valueOf() - b.classMoment.valueOf();
        if (diff !== 0) {
          return diff;
        }

        return a.name.localeCompare(b.name)
      });

      this.loading = false;
      this.pendingEvents = [];
    },
    async getBookings() {
      const apiUrl = `/api/ClubLounge/GetMemberBookings/${this.memberID}`;
      const data = await this.get(apiUrl);
      
      // Handle { item1: [...], item2: [] } response structure
      const bookingsData = data.item1 || (Array.isArray(data) ? data : []);
      
      this.bookings = bookingsData.map(booking => {
        let start = moment(`${booking.displayDate} ${booking.displayTime}`, 'D MMMM h:mm A');
        if (moment().month() === 11 && start.month() === 0) {
          start = start.add(1, 'year');
        }

        return {
          name: booking.className,
          bookingID: booking.bookingID,
          canCancelBooking: booking.canCancelBooking,
          isOnWaitList: booking.isOnWaitList,
          start,
        }
      });
    },
    async getToken() {
      this.loading = true;
      if (this.globalError) return;

      try {
        const data = await this.postToken();
        if (!data.access_token) throw new Error('failed');
        this.authorization = `Bearer ${data.access_token}`;
      } catch (err) {
        this.globalError = 'Authentication failed. Is your Member ID and password correct?';
        this.loading = false;
      }

    },

    getEventColor(event) {
      const matches = this.getBookedClass(event);
      const full = event.spaces <= 0;
      return matches
        ? (matches.isOnWaitList ? '#F9A825' : '#8BC34A') // yellow darken-3 : light-green
        : (full ? '#616161' : '#2196F3'); // grey darken-2 : blue
    },
    getBookedClass(event) {
      return this.bookings.find(booking => {
        const nameMatch = event.name === booking.name;
        const timeMatch = moment(event.classMoment).isSame(booking.start, 'minute');
        return nameMatch && timeMatch;
      });
    },
    async bookClass(event) {
      this.loading = true;
      this.pendingEvents.push(`${event.id}_${event.start}`);
      console.log(event);
      const apiUrl = `/api/ClubLounge/MakeBooking`;
      await this.post(apiUrl, {
        activityID: event.id,
        className: event.name,
        dateTime: moment(event.classMoment).format(),
        dateTimeAsISOString: event.dateTimeAsISOString,
        memberID: parseInt(this.memberID),
        siteID: this.siteID
      });
      this.loading = false;
      this.selectedOpen = false;
      this.refreshDataDebounced();
    },
    async cancelClass(event) {
      this.loading = true;
      this.pendingEvents.push(`${event.id}_${event.start}`);
      const apiUrl = `/api/ClubLounge/CancelBooking`;
      const booking = this.getBookedClass(event);
      if (booking) {
        await this.post(apiUrl, {
          bookingID: booking.bookingID,
          memberID: this.memberID
        });
      }
      this.loading = false;
      this.selectedOpen = false;
      this.refreshDataDebounced();
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => this.selectedOpen = true, 10);
      }

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async checkAdvanceBookings(dateAsISOString) {
      const apiUrl = `/api/ClubLounge/CheckAdvanceBooking`;

      return this.post(apiUrl, {
        bookingsAvailableAfter: 8,
        dateAsISOString,
        isGoldMember: true,
        memberID: this.memberID,
        siteID: this.siteID,
      });
    },
    async get(url) {
      const res = await fetch(`${this.baseApiUrl}${url}`, {
        ...this.fetchOpts,
        headers: {
          ...(this.authorization ? { 'Authorization': this.authorization } : {}),
        }
      });

      if (res.status === 401) {
        await this.getToken();
        if (!this.authorization) return;
        return this.get(url);
      }

      return res.json();
    },
    async post(url, data = {}, opts = { headers: {} }) {
      const res = await fetch(`${this.baseApiUrl}${url}`, {
        ...this.fetchOpts,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(this.authorization ? { 'Authorization': this.authorization } : {}),
          ...opts.headers
        },
        body: JSON.stringify(data)
      });

      if (res.status === 401) {
        await this.getToken();
        if (!this.authorization) return;
        return this.post(url);
      }

      return res.json();
    },
    async postToken() {
      const res = await fetch(`${this.baseApiUrl}/token`, {
        method: 'POST',
        referrer: '',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `username=${this.memberID}&password=${this.password}&grant_type=password`
      });

      return res.json();
    },
    refreshDataDebounced() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.getClasses();
      }, 5000);
    }
  }
}
</script>

<style type="css">

.v-calendar-weekly {
  height: auto !important;
}
#nav-top-gradient {
  height: 5px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  background: linear-gradient(to right,#1c2b39 0%,#e40571 33%,#00aae7 75%,#1c2b39 100%);
}
.pulsing {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>